import { Invitation, InvitationAccessLevel } from '@vi-iot/client';

export function isSendByBuildingManager(invitation: Invitation, companyId: string): boolean {
  return (
    (invitation.accessLevel === InvitationAccessLevel.ServiceContractor ||
      invitation.accessLevel === InvitationAccessLevel.Operator) &&
    invitation.inviterCustomerNumber === companyId
  );
}

export function isSendByLoggedInUser(invitation: Invitation, userId: string): boolean {
  return invitation.inviterAccount === userId;
}
